import * as Colors from 'material-ui/styles/colors';
import { emphasize } from 'material-ui/utils/colorManipulator';

export default {
  iconButtonStyle: {
    padding: '0'
  },
  primaryButtonProperties: {
    backgroundColor: Colors.lightGreen700,
    hoverColor: emphasize(Colors.lightGreen700)
  },
};
